import React from "react";
import { useHistory } from "react-router-dom";
import { ButtonProps, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { importOrderFormRoute } from "../../../OrdersRoutes";

export const ImportOrdersButton: React.FC<ButtonProps> = ({ disabled }: ButtonProps) => {
    const history = useHistory();

    const handleClick = () => {
        history.push(importOrderFormRoute.path);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton onClick={handleClick} text="Import" icon="BulkUpload" disabled={disabled} />
        </AuthorizationWrapper>
    );
};
